// extracted by mini-css-extract-plugin
export default {"seasonal-toggle":"seasonal-toggle--mp-gqJgu","seasonalToggle":"seasonal-toggle--mp-gqJgu"};